
import {reportUrls, sendImpressions, bannerClick} from '@api/index'

import App from "../class/App";

import { device, getMousePosition, getParams2Native, replaceAppFlyerHost, setClickUrl, setNoticeUrl, checkAndroidSDKVersion } from './util'


/**
 * 安卓上报 url （ pv进入页面就上报，只上报一次,展示上报一个offer上报一次 ）
 * 安卓 js给native传数据会出现数据量大于10240的时候会被截断，所以对安卓进行拆分，多次上报
 * @param prams [{type: '', url: only_impression_url}]
 * @param prams [{type: imp_ua, url: impression_url}]
 */
function _reportUrlsAndroid(prams, index) {
    if(index >= prams.length) {console.log("index没有大于length"); return}
    const _this =this;
    console.log("开始reporturl", prams, index)
    return reportURLs([prams[index]]).then(res=>{
        console.log("再次上报下一个")
        _reportUrlsAndroid(prams, ++index)
    }).catch(err=>{
        console.log(err)
    })
    /*util.hybirdEvent({
        sClass: _this.hybirdEventClass,
        hybirdFn: 'reportUrls',/!**!/
        params: [prams[index]],
        succ: function (res) {
            console.log("再次上报下一个")
            _this._reportUrlsAndroid(prams, ++index)
        },
        err: function (err) {
            console.log(err)
        }
    })*/
}

/**
 * 上报 url （ pv进入页面就上报，只上报一次,展示上报一个offer上报一次 ）
 * @param prams [{type: '', url: only_impression_url}]
 * @param prams [{type: imp_ua, url: impression_url}]
 */
export function reportURLs(params) {
    /*util.hybirdEvent({
        sClass: this.hybirdEventClass,
        hybirdFn: 'reportUrls',
        params: params,
        succ: function (res) {
        },
        err: function (err) {
            // util.tips('Sorry, network error...')
        }
    })*/
    console.log("IOS-reporturl", params)
    return reportUrls(params)
}

/**
 * pv统计 无论几个offer都只上报一次，only_impression_url
 */
export function reportPV(URL){
    let arr = []
    if(Array.isArray(URL)){
        URL.forEach(url=>{
            arr.push({ url })
        })
    }else{
        arr.push({ url: URL })
    }
    // 安卓 会超10240，所以对安卓进行拆分，多次上报
    if(device().isAndroid){
        _reportUrlsAndroid(arr, 0)
    }else{
        reportURLs(arr)
    }
}

/**
 * 展示统计 （ 只有offer展示才上报 ）,向sdk传展示的offer的 cid
 * prams ['cid1','cid2']
 *
 */
export function reportImpressions(impressions) {
    /*let arr = bridgeContext.campaignList.map(function(item){
        return item.id
    })
    util.hybirdEvent({
        sClass: this.hybirdEventClass,
        hybirdFn: 'sendImpressions',
        params: arr,
        succ: function (res) {
            console.log("campaignid上报成功")
        },
        err: function (err) {
            console.log("campaignid上报失败")
            console.log(err)
        }
    })*/

    return sendImpressions(impressions)
}

function _iosEnCodeURL(url){
    /*if(device().isiOS){
        return encodeURIComponent(url)
    }*/
    return url
}
/**
 * 上报Offer impression_url,ad_tracking.impression, 一个offer展示一次上报一次，每个offer只上报一次
 */
export function reportOfferImpression(campaignList){
    let arr = [];
    campaignList.forEach((offer)=>{
        arr.push({
            type: offer['imp_ua'],
            url: _iosEnCodeURL(offer['impression_url'])
        })
        const adTrackingImpression = offer.ad_tracking?offer.ad_tracking.impression:"";
        if(adTrackingImpression && Array.isArray(adTrackingImpression) && adTrackingImpression.length>0){
            adTrackingImpression.forEach((item)=>{
                arr.push({
                    url: _iosEnCodeURL(item)
                })
            })
        }else if(adTrackingImpression && typeof adTrackingImpression){
            arr.push({
                url: _iosEnCodeURL(adTrackingImpression)
            })
        }
    })
    //安卓js给native传数据会出现数据量大于10240的时候会被截断，所以对安卓进行拆分，多次上报
    if(device().isAndroid){
        console.log("isAndroid,准备上报安卓impression", arr)
        _reportUrlsAndroid(arr, 0)
    }else{
        console.log("IOS,准备上报IOSimpression", arr)
        reportURLs(arr)
    }
}



export function onScreenClick(event){
    let defaultCampaign =  Object.assign({},this.campaign||{})
    // 用于避免安卓参数过长被截断的问题
    if (device().isAndroid) {
        defaultCampaign = getParams2Native(defaultCampaign);
    }

    // click_url 替换
    let clickPosition = getMousePosition(event);
    let _data = App.initData;
    const _scale = _data.device && _data.device.scale || window.devicePixelRatio;

    if (device().isAndroid){ // 安卓startX,startY返回dp需要乘scale，返回px则不乘scale，这里返回px,本身点击坐标需要乘scale
        clickPosition.x = +clickPosition.x * _scale + (Number(this.windowStartPoint.startX));
        clickPosition.y = +clickPosition.y * _scale + (Number(this.windowStartPoint.startY));
    }else{
        clickPosition.x = (+clickPosition.x + (Number(this.windowStartPoint.startX))) * _scale;
        clickPosition.y = (+clickPosition.y + (Number(this.windowStartPoint.startY))) * _scale;
    }

    clickPosition.scale = _scale
    //  如果是自动storekit，重置坐标
    /*if(autoClick){
        clickPosition.x = -999;
        clickPosition.y = -999;
        defaultCampaign = this.setStorekitStatus(defaultCampaign,isFromMoreOffer);
    }*/
    // 设置clickurl
    defaultCampaign = setClickUrl(defaultCampaign, clickPosition,_data);
    // 设置noticeurl坐标宏替换
    defaultCampaign = setNoticeUrl(defaultCampaign, clickPosition, this.windowStartPoint,false)


    // appflyer替换
    replaceAppFlyerHost(defaultCampaign)

    // 安卓一定要在组装defaultCampaign之前格式化
    if (device().isAndroid){
        defaultCampaign = getParams2Native(defaultCampaign);
    }
    // 如果是banner模板需要组装defaultCampaign

    defaultCampaign = {
        type: 1,
        pt: defaultCampaign
    }
    bannerClick(defaultCampaign).then(res=>{
        console.log(res)
    }).catch(err=>{
        console.error(err)
    })
}